// Use the existing GA property with a fixed public URL. Room links, room names,
// participant names and identities are never sent as analytics dimensions.
export function createTracker(root, base) {
  const measurement = root.dataset.measurementId
  const page = {
    page_location: `${location.origin}${base}`,
    page_title: 'Team Pomodoro Timer',
    page_referrer: location.origin,
  }
  if (measurement) {
    window.dataLayer = window.dataLayer || []
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments)
      }
    window.gtag('js', new Date())
    window.gtag('config', measurement, { ...page, send_page_view: false })
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurement)}`
    document.head.append(script)
    window.gtag('event', 'page_view', page)
  }
  const track = (event, values = {}) => {
    if (
      root.dataset.emailAttribution === 'true' &&
      ['session_started', 'room_created', 'team_active'].includes(event)
    ) {
      // The HttpOnly attribution cookie stays on our server. Neither email
      // identity nor private room information is sent in the beacon or to GA.
      fetch(`${base}/engagement`, {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({ event }),
      }).catch(() => {}) // Measurement must never interrupt the timer.
    }
    if (measurement)
      window.gtag('event', `pomodoro_${event}`, { ...values, ...page })
    root.dispatchEvent(
      new CustomEvent('pomodoro:analytics', { detail: { event, ...values } }),
    )
  }
  try {
    const previous = localStorage.getItem('pomodoro:last_visit')
    const day = new Date().toISOString().slice(0, 10)
    track('visited', {
      returning: Boolean(previous && previous !== day),
      mode: root.dataset.roomId ? 'team' : 'solo',
    })
    localStorage.setItem('pomodoro:last_visit', day)
  } catch {
    track('visited')
  }
  return track
}
